// extracted by mini-css-extract-plugin
module.exports = {"truck":"truck-module--truck--3t63h","truckTextContainer":"truck-module--truckTextContainer--2sfQj","truckImageContainer":"truck-module--truckImageContainer--3Umqs"};